import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { UrlHelperService } from '../../core';
import { BlogPost } from '../model/blog-post';
import { CmsUiDynamicContentQuery } from '../query/cms.query';
import { Breadcrumb, BreadcrumbsResolver } from '../../breadcrumb';

@Injectable({
  providedIn: 'root',
})
export class BlogBreadcrumbResolver extends BreadcrumbsResolver {
  constructor(private cmsQuery: CmsUiDynamicContentQuery, private urlHelper: UrlHelperService) {
    super();
  }

  public override resolve(): Observable<Breadcrumb[]> {
    return this.cmsQuery.blogPosts$.pipe(
      first(),
      map((blogPosts: BlogPost[]) => this.traverse(blogPosts)),
    );
  }

  private traverse(blogPosts: BlogPost[]): Breadcrumb[] {
    if (!blogPosts) {
      return [];
    }

    return blogPosts
      .filter((blogPost: BlogPost) => this.pathMatches(blogPost))
      .map((blogPost: BlogPost) => this.blogPostToBreadcrumb(blogPost));
  }

  private blogPostToBreadcrumb(item: BlogPost): {
    path: string;
    label: string;
    text: string;
    translate: boolean;
    url: string;
  } {
    return {
      label: item.title,
      translate: false,
      url: this.urlHelper.localizeUrl(item.slug),
      path: this.urlHelper.localizeUrl(item.slug),
      text: item.title,
    };
  }

  private pathMatches(item: BlogPost): boolean {
    return this.urlHelper.getPath().substring(3) === item.slug;
  }
}
